<style lang="postcss">
  .hoverable:hover {
    @apply scale-150;
    --tw-scale-x: 2.5;
    --tw-scale-y: 2.5;

  }

  .hoverable:not(:hover) {
    animation: pulse 5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  @keyframes pulse {
    0% {
      opacity: 1;
      transform: scale(1, 1)
    }
    15% {
      opacity: 0.5;
      transform: scale(1.5, 1.5);
    }
    30%, 100% {
      opacity: 1;
      transform: scale(1, 1);
    }
  }

</style>

<script>
  import jazzicon from './../../public/jazzicon';
	import {onMount} from 'svelte';
  import { walletData } from './../stores.js';

  export let localAddress;
  export let diameter;
	let container;
  let address;

	walletData.subscribe(value => {
		address = (localAddress || value['address']);
	});

  var jazziconContent = jazzicon(diameter, parseInt(address.slice(2, 10), 16));

	onMount(() => {
		container.appendChild(jazziconContent);
	});

  $: (address && onAddressUpdate());

  function onAddressUpdate() {
    var jazzIcon = jazzicon(diameter, parseInt(address.slice(2, 10), 16));

    if(document.getElementById(localAddress+'-jazzicon')) {
      document.getElementById(localAddress+'-jazzicon').innerHTML = jazzIcon.outerHTML;
    }
  }

</script>

<div id={localAddress+'-jazzicon'} class="flex items-center hoverable" bind:this={container}/>
